import "./NewSingleItemRequirementDataField.less";

import { Modal, Spin } from "antd";
import React from "react";

import { DataField, StringDataField } from "lib/data/model";
import { IconType } from "lib/data/model/dictionaries/IconTypes";

import { MiniTemplateCard } from "components/general/TemplateCard";

interface INewSingleItemRequirementDataFieldProps {
	addNewDataTemplateRequirement(dataField: DataField): void;
	visible: boolean;
	closeModal(): void;
	waitingForUpdate: boolean;
	dataFieldTypes: DataField[];
}
interface INewSingleItemRequirementDataFieldState {
}

export class NewSingleItemRequirementDataField extends React.Component<INewSingleItemRequirementDataFieldProps, INewSingleItemRequirementDataFieldState>{
	constructor(props: INewSingleItemRequirementDataFieldProps) {
		super(props);
		this.state = {};
	}
	render() {
		return (
			<Modal footer={null} visible={this.props.visible} onCancel={this.props.closeModal}>
				{this.props.waitingForUpdate ?
					<Spin />
					:
					<div className="generic-template-selector">
						<div className="template-selector-group">
							{this.props.dataFieldTypes.map((dataField, key) =>
								<MiniTemplateCard
									onClick={() => this.props.addNewDataTemplateRequirement(dataField)}
									key={key}
									className={"new-template-mini-cards"}
									title={dataField.name}
									iconType={IconType.get(StringDataField.$type)} />)}
						</div>
					</div>
				}
			</Modal>
		);
	}
}
